import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import {
  RequestEditAddressBody,
  AddressInfo,
  requestEditAddress,
  requestUserAddress,
} from '../api/hscan/address';

import { useUserState } from './accountHook';
import { MutationOption } from './react-query-type';

export const useUserAddress = () => {
  const [user] = useUserState();
  const fetch = useCallback(async () => {
    const { data: address, status } = await requestUserAddress();
    if (status !== 200) {
      throw address;
    }
    return address;
  }, []);
  return useQuery({
    queryKey: ['requestUserAddress', user?.userId],
    queryFn: fetch,
    retry: false,
  });
};

export const useUpdateUserAddress = (
  options?: MutationOption<RequestEditAddressBody, AddressInfo>,
) => {
  const queryClient = useQueryClient();
  const mutate = useCallback(async (address: RequestEditAddressBody) => {
    const { data } = await requestEditAddress(address);
    return data;
  }, []);
  return useMutation({
    mutationFn: mutate,
    onSuccess: (...params) => {
      queryClient.invalidateQueries({ queryKey: ['requestUserAddress'] });
      options?.onSuccess?.(...params);
    },
    ...options,
  });
};
